import _regeneratorRuntime from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/chdeploy/jenkins/jenkins/workspace/ch_deploy_webpc_test-jh_clife/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import Vue from 'vue';
import { getLoginInfo } from '@/utils/auth.js';
import * as uMengConstant from '@/constant/uMengConstant';
/**
 *友盟的混入
 * */
export default function () {
  return {
    mounted: function mounted() {
      var _this = this;
      this.$nextTick(function () {
        _this.mixin_register_umeng(_this.mixin_init_umeng);
      });
    },
    methods: {
      // 初始化友盟
      mixin_init_umeng: function mixin_init_umeng(aplus_queue) {
        Vue.prototype.$uMeng = aplus_queue;
        // 集成应用的appKey
        aplus_queue.push({
          action: uMengConstant.UM_SET_META_INFO,
          arguments: [uMengConstant.UM_MATE_NAME_APP_KEY, '621a1be22b8de26e11c96c5f']
        });
        aplus_queue.push({
          action: uMengConstant.UM_SET_META_INFO,
          arguments: [uMengConstant.UM_MATE_NAME_WAITING, 'MAN']
        });
        // 是否开启调试模式
        aplus_queue.push({
          action: uMengConstant.UM_SET_META_INFO,
          arguments: ['DEBUG', false]
        });
      },
      // 注册友盟SDK
      mixin_register_umeng: function () {
        var _mixin_register_umeng = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(callback) {
          var version, src, javascript;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  version = '203467608';
                  src = "https://d.alicdn.com/alilog/mlog/aplus/".concat(version, ".js");
                  javascript = document.createElement('script');
                  javascript.async = true;
                  javascript.language = 'JavaScript';
                  javascript.id = 'beacon-aplus';
                  javascript.src = src;
                  document.body.appendChild(javascript);
                  if (javascript.readyState) {
                    // IE
                    javascript.onreadystatechange = function () {
                      if (javascript.readyState === 'complete' || javascript.readyState === 'loaded') {
                        javascript.onreadystatechange = null;
                        callback(window.aplus_queue);
                      }
                    };
                  } else {
                    // 非IE
                    javascript.onload = function () {
                      callback(window.aplus_queue);
                    };
                  }
                case 9:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
        function mixin_register_umeng(_x) {
          return _mixin_register_umeng.apply(this, arguments);
        }
        return mixin_register_umeng;
      }()
    },
    watch: {
      '$route.path': function $routePath(newVal, oldVal) {
        // 关闭路由跳转时触发的埋点;
        if (this.$uMeng) {
          var org = getLoginInfo().org;
          this.$uMeng.push({
            action: uMengConstant.UM_SEND_PV,
            arguments: [{
              is_auto: false
            }, {
              newVal: newVal,
              oldVal: oldVal,
              regionId: org && org.regionId
            }]
          });
        }
      }
    }
  };
}